'use es6';

import Client from 'AdsUI/data/Client';
import getAccountIdsByNetwork from 'AdsUI/lib/getAccountIdsByNetwork';
const baseUrl = 'ads/v1/drafts';
export const fetchAvailableDrafts = adAccounts => {
  return Client.apiRequest(`${baseUrl}/available`, {
    query: Object.assign({}, getAccountIdsByNetwork(adAccounts))
  });
};
export const createLeadAdDraft = (network, adAccountId, name, draft) => {
  return Client.apiRequest(`${baseUrl}/${network.toLowerCase()}/ad`, {
    type: 'POST',
    data: {
      adAccountId,
      name,
      draft
    }
  });
};
export const updateLeadAdDraft = (id, network, adAccountId, name, draft) => {
  return Client.apiRequest(`${baseUrl}/${network.toLowerCase()}/ad/${id}`, {
    type: 'PUT',
    data: {
      adAccountId,
      name,
      draft
    }
  });
};
export const deleteDraft = (id, network, type) => {
  return Client.apiRequest(`${baseUrl}/${network.toLowerCase()}/${type}/${id}`, {
    type: 'DELETE'
  });
};
export const createSequenceDraft = (network, adAccountId, name, draft) => {
  return Client.apiRequest(`${baseUrl}/${network.toLowerCase()}/sequence`, {
    type: 'POST',
    data: {
      adAccountId,
      name,
      draft
    }
  });
};
export const updateSequenceDraft = (id, network, adAccountId, name, draft) => {
  return Client.apiRequest(`${baseUrl}/${network.toLowerCase()}/sequence/${id}`, {
    type: 'PUT',
    data: {
      adAccountId,
      name,
      draft
    }
  });
};